export default "__VITE_ASSET__CDsLPb$z__"